'use client'

import { useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import { _promotions } from '@/_mock/_home'
import type { Promotion } from '@/@types'
import { ROUTES } from '@/config/routes'
import PromotionCard, { PromotionCardSkeleton } from '../promotions/PromotionCard'
import { HomeSection } from "./HomeSection"

type Props = {
  promotions: Promotion[]
}

export function Promotion({ promotions }: Props) {
  const swiperRef = useRef<any>(null)
  const [isLoading, setIsLoading] = useState(true)

  return (
    <HomeSection
      title="CONOCE NUESTRAS PROMOCIONES"
      mobileTitle="PROMOCIONES"
      viewAllLink={ROUTES.promotions.root}
      className="bg-white pb-[0.1px]"
    >
      <div className="relative w-screen left-1/2 right-1/2 -mx-[50vw]">
        {isLoading && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 px-4">
            {[...Array(4)].map((_, index) => (
              <PromotionCardSkeleton key={index} />
            ))}
          </div>
        )}
        <div className={isLoading ? 'hidden' : ''}>
          <Swiper
            modules={[Navigation]}
            slidesPerView={1.2}
            breakpoints={{
              480: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: promotions.length > 4 ? 5 : 4 },
            }}
            navigation={{
              prevEl: '.swiper-button-prev',
              nextEl: '.swiper-button-next',
            }}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
              setIsLoading(false);
            }}
            className="pb-8"
          >
            {promotions.map((promotion) => (
              <SwiperSlide key={promotion.id} className="!h-auto flex">
                <div className="h-full w-full">
                  <PromotionCard item={{ promotions: [promotion] }} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </HomeSection>
  )
}